import { graphql } from "~/gql";

export const CREATE_WORK = graphql(/* GraphQL */ `
  mutation createAndAddWork($data: WorkCreateInput!) {
    createAndAddWork(data: $data) {
      ...WorkParts
    }
  }
`);
